// This file is auto-generated. Do not modify directly.
// biome-ignore: auto-generated file
// biome-ignore format: auto-generated file
// eslint-disable

export const productCatalog = {
  "A-100": {
    "productType": null,
    "displayName": "BL staff Member - Blue Lagoon Admission",
    "fullName": "BL staff Member - Blue Lagoon Admission"
  },
  "A-101": {
    "productType": null,
    "displayName": "BL staff Invited guest - Blue Lagoon Admission",
    "fullName": "BL staff Invited guest - Blue Lagoon Admission"
  },
  "A-102": {
    "productType": null,
    "displayName": "BL staff Invited child - Blue Lagoon Admission",
    "fullName": "BL staff Invited child - Blue Lagoon Admission"
  },
  "A-102A": {
    "productType": null,
    "displayName": "BL Staff invited child",
    "fullName": "BL Staff invited child"
  },
  "A-BL-404": {
    "productType": null,
    "displayName": "Children's BL SPA Access",
    "fullName": "Children's BL SPA Access"
  },
  "A-BL-410A": {
    "productType": null,
    "displayName": "Comfort",
    "fullName": "Comfort"
  },
  "A-BL-416": {
    "productType": null,
    "displayName": "Comfort - Child",
    "fullName": "Comfort - Child"
  },
  "A-BL-417": {
    "productType": null,
    "displayName": "Comfort - S",
    "fullName": "Comfort - S"
  },
  "A-BL-420A": {
    "productType": null,
    "displayName": "Premium",
    "fullName": "Premium"
  },
  "A-BL-428": {
    "productType": null,
    "displayName": "Premium - Child",
    "fullName": "Premium - Child"
  },
  "A-BL-429": {
    "productType": null,
    "displayName": "Premium - S",
    "fullName": "Premium - S"
  },
  "A-BL-430": {
    "productType": null,
    "displayName": "Signature",
    "fullName": "Signature"
  },
  "API-BL-410A": {
    "productType": null,
    "displayName": "Comfort",
    "fullName": "Comfort"
  },
  "API-BL-420A": {
    "productType": null,
    "displayName": "Premium",
    "fullName": "Premium"
  },
  "ARCTIC EXPOSURE": {
    "productType": null,
    "displayName": "Guided Reykjanes Photo Tour",
    "fullName": "Guided Reykjanes Photo Tour"
  },
  "B-071": {
    "productType": "Admission",
    "displayName": "BL Winter Card - Individual Admission",
    "fullName": "BL Winter Card - Individual Admission"
  },
  "B-138": {
    "productType": "Admission",
    "displayName": "BL Summer Card - Individual Admission",
    "fullName": "BL Summer Card - Individual Admission"
  },
  "B-217": {
    "productType": "Massage",
    "displayName": "30 min - In Water Relaxing Massage",
    "fullName": "30 min-In Water Relaxing Massage"
  },
  "B-218": {
    "productType": "Massage",
    "displayName": "60 min - In Water Relaxing Massage",
    "fullName": "60 min-In Water Relaxing Massage"
  },
  "B-229": {
    "productType": "Massage",
    "displayName": "Signature Treatment: 120 min of Wonder",
    "fullName": "Signature Treatment: 120 min of Wonder"
  },
  "B-230": {
    "productType": "Massage",
    "displayName": "Floating for one",
    "fullName": "Floating for one "
  },
  "B-230A": {
    "productType": "Massage",
    "displayName": "Floating for two",
    "fullName": "Floating for two"
  },
  "B-230B": {
    "productType": "Massage",
    "displayName": "Group Float",
    "fullName": "Floating - Samflot"
  },
  "G-BL-191": {
    "productType": null,
    "displayName": "Admission - Guide/Tourleader",
    "fullName": "Admission - Guide/Tourleader"
  },
  "G-BL-404": {
    "productType": "Admission",
    "displayName": "Children",
    "fullName": "Children's BL SPA Access"
  },
  "G-BL-410A": {
    "productType": "Admission",
    "displayName": "Comfort",
    "fullName": "Comfort"
  },
  "G-BL-420A": {
    "productType": "Admission",
    "displayName": "Premium",
    "fullName": "Premium"
  },
  "G-BL-430": {
    "productType": "Admission",
    "displayName": "Signature",
    "fullName": "Signature"
  },
  "G-BL-430A": {
    "productType": "Admission",
    "displayName": "Seasonal",
    "fullName": "Valentines"
  },
  "G-BL-430B": {
    "productType": null,
    "displayName": "Easter's",
    "fullName": "Easter's"
  },
  "H-TA39": {
    "productType": null,
    "displayName": "Blowdry and hairstyling",
    "fullName": "Blowdry and hairstyling"
  },
  "KATLA TRACK-1": {
    "productType": null,
    "displayName": "Katla Ice Cave Tour - Fast Track",
    "fullName": "Katla Ice Cave Tour - Fast Track"
  },
  "KATLA TRACK-2": {
    "productType": null,
    "displayName": "Katla Ice Cave Tour",
    "fullName": "Katla Ice Cave Tour"
  },
  "KATLA TRACK-3": {
    "productType": null,
    "displayName": "Black Beach Buggy Tour",
    "fullName": "Black Beach Buggy Tour"
  },
  "LAVA-RES": {
    "productType": "Restaurant",
    "displayName": "LAVA Table Reservation",
    "fullName": "LAVA Table Reservation"
  },
  "MOSS-RES": {
    "productType": "Restaurant",
    "displayName": "MOSS Table Reservation",
    "fullName": "MOSS Table Reservation"
  },
  "R-105": {
    "productType": "Transfer",
    "displayName": "DBL Two way transfer",
    "fullName": "Two way transfer - All booking members included"
  },
  "SERVIO - 2": {
    "productType": "PrivateTransfer",
    "displayName": "Transfer - Blue Lagoon - Kef Airport - Luxury Sedan (1-2 pax)",
    "fullName": "Transfer - Blue Lagoon - Kef Airport - Luxury Sedan (1-2 pax)"
  },
  "SERVIO - 2A": {
    "productType": "PrivateTransfer",
    "displayName": "Transfer - Blue Lagoon - Kef Airport - Business Minivan (1-4 pax)",
    "fullName": "Transfer - Blue Lagoon - Kef Airport - Business Minivan (1-4 pax)"
  },
  "SERVIO - 2B": {
    "productType": "PrivateTransfer",
    "displayName": "Transfer - Blue Lagoon - Kef Airport - Sprinter (1-9 pax)",
    "fullName": "Transfer - Blue Lagoon - Kef Airport - Sprinter (1-9 pax)"
  },
  "SERVIO - 3": {
    "productType": "PrivateTransfer",
    "displayName": "Transfer - Kef Airport - BL -  Luxury Sedan (1-2 pax)",
    "fullName": "Transfer - Kef Airport - BL -  Luxury Sedan (1-2 pax) "
  },
  "SERVIO - 3A": {
    "productType": "PrivateTransfer",
    "displayName": "Transfer -  Kef Airport - BL  - Business Minivan (1-4 pax)",
    "fullName": "Transfer -  Kef Airport - BL  - Business Minivan (1-4 pax)"
  },
  "SERVIO - 3B": {
    "productType": "PrivateTransfer",
    "displayName": "Transfer - Kef Airport - BL  - Sprinter (1-9 pax)",
    "fullName": "Transfer - Kef Airport - BL  - Sprinter (1-9 pax)"
  },
  "SPA-RES": {
    "productType": "Restaurant",
    "displayName": "SPA Restaurant Table Reservation",
    "fullName": "Spa Restaurant Table Reservation"
  },
  "T-100": {
    "productType": "Admission",
    "displayName": "The Retreat Spa",
    "fullName": "The Retreat SPA"
  },
  "T-100I": {
    "productType": "Admission",
    "displayName": "The Retreat SPA - Full Day Access",
    "fullName": "The Retreat SPA - Full Day Access"
  },
  "VALDEMAR - 13": {
    "productType": "PrivateTransfer",
    "displayName": "Blue Lagoon - KEF Airport(4-8pax)",
    "fullName": "Taxi Transfer - Blue Lagoon - KEF Airport (4-8pax)"
  },
  "VALDEMAR - 14": {
    "productType": "PrivateTransfer",
    "displayName": "KEF Airport - Blue Lagoon(4-8pax)",
    "fullName": "Taxi Transfer - KEF Airport - Blue Lagoon (4-8pax)"
  },
  "VALDEMAR - 2": {
    "productType": "PrivateTransfer",
    "displayName": "Blue Lagoon - KEF Airport(1-3pax)",
    "fullName": "Taxi Transfer - Blue Lagoon - KEF Airport (1-3pax)"
  },
  "VALDEMAR - 3": {
    "productType": "PrivateTransfer",
    "displayName": "KEF Airport - Blue Lagoon(1-3pax)",
    "fullName": "Taxi Transfer - KEF Airport - Blue Lagoon (1-3pax)"
  },
  "BL1B01F1": {
    "productType": "Item",
    "displayName": "Silica Mud Mask 75ml",
    "fullName": "Silica Mud Mask 75ml"
  },
  "V-MOK-4001": {
    "productType": "Item",
    "displayName": "Moss 7-course menu",
    "fullName": "Moss 7-course menu"
  },
  "RETREAT-LAGO": {
    "productType": "Hotel",
    "displayName": "Lagoon View Junior King",
    "fullName": "KING"
  },
  "RETREAT-LASU": {
    "productType": "Hotel",
    "displayName": "Lagoon Suite",
    "fullName": "KING"
  },
  "RETREAT-LATW": {
    "productType": "Hotel",
    "displayName": "Lava View Junior Twin",
    "fullName": "TWIN"
  },
  "RETREAT-LAVA": {
    "productType": "Hotel",
    "displayName": "Lava View Junior King",
    "fullName": "KING"
  },
  "RETREAT-MOSS": {
    "productType": "Hotel",
    "displayName": "Moss Junior suite King",
    "fullName": "KING"
  },
  "RETREAT-MOSU": {
    "productType": "Hotel",
    "displayName": "Moss suite King",
    "fullName": "KING"
  },
  "RETREAT-MOTW": {
    "productType": "Hotel",
    "displayName": "Moss Junior suite Twin",
    "fullName": "TWIN"
  },
  "RETREAT-ALL": {
    "productType": "Hotel",
    "displayName": "All room types",
    "fullName": "All Retreat Hotel room types"
  },
  "SILICA-LAKI": {
    "productType": "Hotel",
    "displayName": "Lava Deluxe King",
    "fullName": "KING"
  },
  "SILICA-LATW": {
    "productType": "Hotel",
    "displayName": "Lava Deluxe Twin",
    "fullName": "TWIN"
  },
  "SILICA-MOKI": {
    "productType": "Hotel",
    "displayName": "Mountain Deluxe King",
    "fullName": "KING"
  },
  "SILICA-MOTW": {
    "productType": "Hotel",
    "displayName": "Mountain Deluxe Twin",
    "fullName": "TWIN"
  },
  "SILICA-SILI": {
    "productType": "Hotel",
    "displayName": "SILI",
    "fullName": "KING"
  },
  "SILICA-ALL": {
    "productType": "Hotel",
    "displayName": "All room types",
    "fullName": "All Silica Hotel room types"
  },
  "BL4B05F2-4": {
    "productType": "Item",
    "displayName": "Signature full size mask kit",
    "fullName": "Signature full size mask kit"
  },
  "BL4N20F": {
    "productType": "Item",
    "displayName": "BL+ signature kit",
    "fullName": "BL+ signature kit"
  },
  "BL4N49F": {
    "productType": "InRoom",
    "displayName": "The Ultimate Indulgence",
    "fullName": "The Ultimate Indulgence"
  },
  "BL4B05M4": {
    "productType": "InRoom",
    "displayName": "Signature Masks Travel - 4x30 ml",
    "fullName": "Signature Masks Travel - 4x30 ml"
  },
  "BL4B06F": {
    "productType": "InRoom",
    "displayName": "Ritual kit",
    "fullName": "Ritual kit"
  },
  "BL1N20F": {
    "productType": "InRoom",
    "displayName": "BL+ the serum 30ml",
    "fullName": "BL+ the serum 30ml"
  },
  "BL1N21F": {
    "productType": "InRoom",
    "displayName": "BL+ eye serum 10ml",
    "fullName": "BL+ eye serum 10ml"
  },
  "BL1N26F": {
    "productType": "InRoom",
    "displayName": "BL+ the cream 50ml",
    "fullName": "BL+ the cream 50ml"
  },
  "BL1N30M": {
    "productType": "InRoom",
    "displayName": "BL+ eye cream 15ml",
    "fullName": "BL+ eye cream 15ml"
  },
  "V-ROM-100": {
    "productType": "InRoom",
    "displayName": "Mixed Fruits",
    "fullName": "Mixed Fruits"
  },
  "V-ROM-101": {
    "productType": "InRoom",
    "displayName": "Omelette",
    "fullName": "Omelette"
  },
  "V-ROM-102": {
    "productType": "InRoom",
    "displayName": "Egg White Omelette",
    "fullName": "Egg White Omelette"
  },
  "V-ROM-103": {
    "productType": "InRoom",
    "displayName": "Scrambled Eggs",
    "fullName": "Scrambled Eggs"
  },
  "V-ROM-104": {
    "productType": "InRoom",
    "displayName": "Crispy Bacon",
    "fullName": "Crispy Bacon"
  },
  "V-ROM-105": {
    "productType": "InRoom",
    "displayName": "Roasted Potatoes",
    "fullName": "Roasted Potatoes"
  },
  "V-ROM-106": {
    "productType": "InRoom",
    "displayName": "Oatmeal",
    "fullName": "Oatmeal"
  },
  "V-ROM-107": {
    "productType": "InRoom",
    "displayName": "Skyr",
    "fullName": "Skyr"
  },
  "V-ROM-108": {
    "productType": "InRoom",
    "displayName": "Vegetable Tray",
    "fullName": "Vegetable Tray"
  },
  "V-ROM-109": {
    "productType": "InRoom",
    "displayName": "Croissant",
    "fullName": "Croissant"
  },
  "V-ROM-110": {
    "productType": "InRoom",
    "displayName": "Gluten free bread",
    "fullName": "Gluten free bread"
  },
  "V-ROM-111": {
    "productType": "InRoom",
    "displayName": "Muffins",
    "fullName": "Muffins"
  },
  "V-ROM-112": {
    "productType": "InRoom",
    "displayName": "Chocolate and dates",
    "fullName": "Chocolate and dates"
  },
  "V-ROM-114": {
    "productType": "InRoom",
    "displayName": "Vegan Meatballs",
    "fullName": "Vegan Meatballs"
  },
  "V-ROM-204": {
    "productType": "InRoom",
    "displayName": "Cod",
    "fullName": "Cod"
  },
  "V-ROM-205": {
    "productType": "InRoom",
    "displayName": "Sushi",
    "fullName": "Sushi"
  },
  "V-ROM-210": {
    "productType": "InRoom",
    "displayName": "Burrata",
    "fullName": "Burrata"
  },
  "V-ROM-211": {
    "productType": "InRoom",
    "displayName": "Mediterranean Salad",
    "fullName": "Mediterranean Salad"
  },
  "V-ROM-212": {
    "productType": "InRoom",
    "displayName": "Tuna Tartare",
    "fullName": "Tuna Tartare"
  },
  "V-ROM-300": {
    "productType": "InRoom",
    "displayName": "Aubergine hummus",
    "fullName": "Aubergine hummus"
  },
  "V-ROM-303": {
    "productType": "InRoom",
    "displayName": "Avocado & seed crackers",
    "fullName": "Avocado & seed crackers"
  },
  "V-ROM-304": {
    "productType": "InRoom",
    "displayName": "Hummus & seed crackers",
    "fullName": "Hummus & seed crackers"
  },
  "V-ROM-308": {
    "productType": "InRoom",
    "displayName": "Crudité and basil hummus - regular",
    "fullName": "Crudité and basil hummus - regular"
  },
  "V-ROM-309": {
    "productType": "InRoom",
    "displayName": "Crudité and basil hummus - large",
    "fullName": "Crudité and basil hummus - large"
  },
  "V-ROM-312": {
    "productType": "InRoom",
    "displayName": "Greek salad",
    "fullName": "Greek salad"
  },
  "V-ROM-314": {
    "productType": "InRoom",
    "displayName": "Farro salad",
    "fullName": "Farro salad"
  },
  "V-ROM-402": {
    "productType": "InRoom",
    "displayName": "Miso Soup",
    "fullName": "Miso Soup"
  },
  "V-ROM-403": {
    "productType": "InRoom",
    "displayName": "Beef Tataki",
    "fullName": "Beef Tataki"
  },
  "V-ROM-405": {
    "productType": "InRoom",
    "displayName": "Caesar Salad",
    "fullName": "Caesar Salad"
  },
  "V-ROM-404": {
    "productType": "InRoom",
    "displayName": "Grilled panini",
    "fullName": "Grilled panini"
  },
  "V-ROM-408": {
    "productType": "InRoom",
    "displayName": "Avocado toast",
    "fullName": "Avocado toast"
  },
  "V-ROM-409": {
    "productType": "InRoom",
    "displayName": "BLT sandwich",
    "fullName": "BLT sandwich"
  },
  "V-ROM-410": {
    "productType": "InRoom",
    "displayName": "Smoked salmon",
    "fullName": "Smoked salmon"
  },
  "V-ROM-411": {
    "productType": "InRoom",
    "displayName": "Carrots",
    "fullName": "Carrots"
  },
  "V-ROM-412": {
    "productType": "InRoom",
    "displayName": "Beluga Caviar",
    "fullName": "Beluga Caviar"
  },
  "V-ROM-413": {
    "productType": "InRoom",
    "displayName": "Oscietra Caviar",
    "fullName": "Oscietra Caviar"
  },
  "V-ROM-414": {
    "productType": "InRoom",
    "displayName": "Gold Selection Caviar",
    "fullName": "Gold Selection Caviar"
  },
  "V-ROM-500": {
    "productType": "InRoom",
    "displayName": "Fruit salad",
    "fullName": "Fruit salad"
  },
  "V-ROM-501": {
    "productType": "InRoom",
    "displayName": "Dark chocolate mousse",
    "fullName": "Dark chocolate mousse"
  },
  "V-ROM-502": {
    "productType": "InRoom",
    "displayName": "Créme Brulée",
    "fullName": "Créme Brulée"
  },
  "V-ROM-503": {
    "productType": "InRoom",
    "displayName": "Chocolate mousse and berries",
    "fullName": "Chocolate mousse and berries"
  },
  "T-112": {
    "productType": "InRoom",
    "displayName": "Room service charge",
    "fullName": "Room service charge"
  },
  "BL4N22F": {
    "productType": "Item",
    "displayName": "Discovery BL+",
    "fullName": "Discovery BL+"
  },
  "V-OLG-66502": {
    "productType": "Item",
    "displayName": "Moet & Chandon",
    "fullName": "Moet & Chandon"
  },
  "V-OLG-60442": {
    "productType": "Item",
    "displayName": "Prosecco",
    "fullName": "Prosecco"
  },
  "V-MOK-3004": {
    "productType": "Item",
    "displayName": "Chocolates and Strawberries",
    "fullName": "Chocolates and Strawberries"
  },
  "A-200": {
    "productType": "Admission",
    "displayName": "Admission adult",
    "fullName": "Bath Admission - Adult"
  },
  "A-201": {
    "productType": "Admission",
    "displayName": "Admission teenager",
    "fullName": "Bath Admission - Teenager"
  },
  "A-202": {
    "productType": "Admission",
    "displayName": "Admission child",
    "fullName": "Bath Admission - Child"
  },
  "BUGGY-1": {
    "productType": "Activity",
    "displayName": "BUGGY-1 ∙ Buggy Single Ride - 1 hour",
    "fullName": "Buggy Single Ride  - 1 hour"
  },
  "BUGGY-2": {
    "productType": "Activity",
    "displayName": "BUGGY-2 ∙ Buggy Double ride - 1 hour",
    "fullName": "Buggy Double ride - 1 hour"
  },
  "EBIKES": {
    "productType": "Activity",
    "displayName": "Bikes",
    "fullName": "E-Mountain Bike Tour"
  },
  "G-BL-100": {
    "productType": null,
    "displayName": "Day Tour from Reykjavík",
    "fullName": "Day Tour from Reykjavík"
  },
  "G-BL-101": {
    "productType": null,
    "displayName": "Day Tour from Gullfoss",
    "fullName": "Day Tour from Gullfoss"
  },
  "KER-RES": {
    "productType": "Restaurant",
    "displayName": "Highland Base Table Reservation",
    "fullName": "Kerlingafjöll Restaurant Table Reservation"
  },
  "R-1000": {
    "productType": "Transfer",
    "displayName": "Rvk Sightseeing Two way transfer",
    "fullName": "Two Way Bus Transfer"
  },
  "SNOW-1": {
    "productType": "Activity",
    "displayName": "Snowmobile double ride",
    "fullName": "Snowmobiles Single Ride - 1 hour"
  },
  "SNOW-2": {
    "productType": "Activity",
    "displayName": "Snowmobile single ride",
    "fullName": "Snowmobiles Double Ride - 1 hour"
  },
  "SOUTH-10": {
    "productType": null,
    "displayName": "Bus Transfer Gullfoss - HB - Gullfoss",
    "fullName": "Bus Transfer Gullfoss - HB - Gullfoss"
  },
  "SOUTH-11": {
    "productType": null,
    "displayName": "Bus Transfer RVK-HB-RVK",
    "fullName": "Bus Transfer RVK-HB-RVK"
  },
  "SOUTH-6": {
    "productType": null,
    "displayName": "Bus Transfer Reykjavík  - Highland Base",
    "fullName": "Bus Transfer Reykjavík  - Highland Base"
  },
  "SOUTH-7": {
    "productType": null,
    "displayName": "Bus Transfer Gullfoss - Highland Base ",
    "fullName": "Bus Transfer Gullfoss - Highland Base "
  },
  "SOUTH-8": {
    "productType": null,
    "displayName": "Bus Transfer Highland Base - Reykjavík",
    "fullName": "Bus Transfer Highland Base - Reykjavík"
  },
  "SOUTH-9": {
    "productType": null,
    "displayName": "Bus Transfer Higland Base - Gullfoss",
    "fullName": "Bus Transfer Higland Base - Gullfoss"
  },
  "TRANSFER-HB-RVK": {
    "productType": "Activity",
    "displayName": "Super Jeep HB to Reykjavik",
    "fullName": "Super Jeep transfer from Highland Base to Reykjavik"
  },
  "TRANSFER-HB-SKJOL": {
    "productType": "Activity",
    "displayName": "Super Jeep HB to Skjól",
    "fullName": "Super Jeep transfer from Highland Base to Skjól basecamp"
  },
  "TRANSFER-RVK-HB": {
    "productType": "Activity",
    "displayName": "Super Jeep Reykjavik to HB",
    "fullName": "Super Jeep Transfer from Reykjavik to Highland Base"
  },
  "TRANSFER-SKJOL-HB": {
    "productType": "Activity",
    "displayName": "Super Jeep Skjól to HB",
    "fullName": "Super Jeep transfer from Skjól Basecamp to Highland Base"
  },
  "KERLINGARFJOLL-DLX_DOUBLE": {
    "productType": "Hotel",
    "displayName": "Deluxe Double Room",
    "fullName": "DOUBLE"
  },
  "KERLINGARFJOLL-DLX_TWIN": {
    "productType": "Hotel",
    "displayName": "Deluxe Twin Room",
    "fullName": "TWIN"
  },
  "KERLINGARFJOLL-HUT_SB_15PAX": {
    "productType": "Hotel",
    "displayName": "Hut for 10-15 guests",
    "fullName": "SLEEPING BAG"
  },
  "KERLINGARFJOLL-HUT_SB_2PAX": {
    "productType": "Hotel",
    "displayName": "Hut for 2 guests",
    "fullName": "SLEEPING BAG"
  },
  "KERLINGARFJOLL-HUT_SB_3PAX": {
    "productType": "Hotel",
    "displayName": "Hut for 3 guests",
    "fullName": "SLEEPING BAG"
  },
  "KERLINGARFJOLL-HUT_SB_6PAX": {
    "productType": "Hotel",
    "displayName": "Hut for 4-6 guests",
    "fullName": "SLEEPING BAG"
  },
  "KERLINGARFJOLL-LODGE": {
    "productType": "Hotel",
    "displayName": "Highland Base Lodge",
    "fullName": "DOUBLE"
  },
  "KERLINGARFJOLL-LODGE+SOFABED": {
    "productType": "Hotel",
    "displayName": "Highland Base Lodge with sofa bed",
    "fullName": "DOUBLE + SOFABED"
  },
  "KERLINGARFJOLL-PREMIUM": {
    "productType": "Hotel",
    "displayName": "Deluxe Family Room",
    "fullName": "DOUBLE + SOFABED"
  },
  "KERLINGARFJOLL-STD_FAM": {
    "productType": "Hotel",
    "displayName": "Standard Family Room",
    "fullName": "QUEEN BUNK"
  },
  "KERLINGARFJOLL-STD_TWIN": {
    "productType": "Hotel",
    "displayName": "Standard Twin Room",
    "fullName": "TWIN"
  },
  "KERLINGARFJOLL-SUITE": {
    "productType": "Hotel",
    "displayName": "Highland Base Suite",
    "fullName": "DOUBLE"
  },
  "KERLINGARFJOLL-ALL": {
    "productType": "Hotel",
    "displayName": "All room types",
    "fullName": "All Highland Base room types"
  },
  "valentines": {
    "productType": "analyticsItem",
    "displayName": "Valentines",
    "fullName": "Valentines"
  },
  "signature": {
    "productType": "analyticsItem",
    "displayName": "Signature",
    "fullName": "Signature"
  },
  "retreatspa": {
    "productType": "analyticsItem",
    "displayName": "Retreatspa",
    "fullName": "Retreatspa"
  },
  "premium": {
    "productType": "analyticsItem",
    "displayName": "Premium",
    "fullName": "Premium"
  },
  "comfort": {
    "productType": "analyticsItem",
    "displayName": "Comfort",
    "fullName": "Comfort"
  },
  "retreat": {
    "productType": "analyticsItem",
    "displayName": "Retreat Hotel",
    "fullName": "Retreat Hotel"
  },
  "silica": {
    "productType": "analyticsItem",
    "displayName": "Silica Hotel",
    "fullName": "Silica Hotel"
  },
  "retreatLavaViewJuniorSuite": {
    "productType": "analyticsItem",
    "displayName": "Retreat Hotel Lava View Junior Suite",
    "fullName": "Retreat Hotel Lava View Junior Suite"
  },
  "retreatMossSuite": {
    "productType": "analyticsItem",
    "displayName": "Retreat Hotel Moss Suite",
    "fullName": "Retreat Hotel Moss Suite"
  },
  "retreatLagoonSuite": {
    "productType": "analyticsItem",
    "displayName": "Retreat Hotel Lagoon Suite",
    "fullName": "Retreat Hotel Lagoon Suite"
  },
  "silicaMountainDeluxe": {
    "productType": "analyticsItem",
    "displayName": "Silica Mountain Deluxe Room",
    "fullName": "Silica Mountain Deluxe Room"
  },
  "silicaLavaDeluxe": {
    "productType": "analyticsItem",
    "displayName": "Silica Lava Deluxe Room",
    "fullName": "Silica Lava Deluxe Room"
  },
  "silicaDeluxe": {
    "productType": "analyticsItem",
    "displayName": "Silica Deluxe Room",
    "fullName": "Silica Deluxe Room"
  },
  "GONGUSKIDI": {
    "productType": "highlandPackage",
    "displayName": "Cross-Country Skiiing",
    "fullName": "Cross-Country Skiiing"
  },
  "EASTER": {
    "productType": "highlandPackage",
    "displayName": "Easter Special",
    "fullName": "Easter Special"
  },
  "SNOWMOBILE_NEW": {
    "productType": "highlandPackage",
    "displayName": "Snowmobiling in the Extremes",
    "fullName": "Snowmobiling in the Extremes"
  },
  "VALENTINE": {
    "productType": "highlandPackage",
    "displayName": "Heartwarming weekend adventure  ",
    "fullName": "Heartwarming weekend adventure  "
  },
  "HEILSUHELGI": {
    "productType": "highlandPackage",
    "displayName": "Heilsuhelgi",
    "fullName": "Heilsuhelgi"
  },
  "ADVENT": {
    "productType": "highlandPackage",
    "displayName": "A festive getaway ",
    "fullName": "A festive getaway "
  },
  "SKIDA": {
    "productType": "highlandPackage",
    "displayName": "Ævintýralegt skíðanámskeið",
    "fullName": "Ævintýralegt skíðanámskeið"
  },
  "HBE_ONLINE": {
    "productType": "highlandPackage",
    "displayName": "Stay at Highland Base",
    "fullName": "Stay at Highland Base"
  },
  "2FYRIR1": {
    "productType": "highlandPackage",
    "displayName": " Tvær nætur á verði einnar í Kerlingarfjöllum",
    "fullName": " Tvær nætur á verði einnar í Kerlingarfjöllum"
  },
  "LAST_MINUTE": {
    "productType": "highlandPackage",
    "displayName": "Summer at Highland Base",
    "fullName": "Summer at Highland Base"
  },
  "FIVE_PEAKS": {
    "productType": "highlandPackage",
    "displayName": "Five Peaks Hiking Weekend",
    "fullName": "Five Peaks Hiking Weekend"
  },
  "AURORA_ADVENTURE": {
    "productType": "highlandPackage",
    "displayName": "Highland Aurora Adventure",
    "fullName": "Highland Aurora Adventure"
  },
  "FJALLASKIDI": {
    "productType": "highlandPackage",
    "displayName": "Backcountry Skiing",
    "fullName": "Backcountry Skiing"
  },
  "RACK SLEEPING BAG": {
    "productType": "highlandPackage",
    "displayName": "Stay at Highland Base Huts",
    "fullName": "Stay at Highland Base Huts"
  },
  "HBE_NO TRANSFER": {
    "productType": "highlandPackage",
    "displayName": "No transfer",
    "fullName": "No transfer"
  },
  "RETREAT_HELICOPER": {
    "productType": "pagePackage",
    "displayName": "Wonders of the Earth & Sky",
    "fullName": "Wonders of the Earth & Sky"
  },
  "RETREAT_ROMANTIC": {
    "productType": "pagePackage",
    "displayName": "A Romantic Getaway",
    "fullName": "A Romantic Getaway"
  },
  "ROMANCE AND RADIANCE": {
    "productType": "pagePackage",
    "displayName": "Romance & Radiance",
    "fullName": "Romance & Radiance"
  },
  "KITCHEN_TABLE": {
    "productType": "pagePackage",
    "displayName": "Kitchen’s Table Adventure ",
    "fullName": "Kitchen’s Table Adventure "
  },
  "WELLNESS AND WONDER": {
    "productType": "pagePackage",
    "displayName": "Wellness & Wonder",
    "fullName": "Wellness & Wonder"
  },
  "RETREAT_REC": {
    "productType": "pagePackage",
    "displayName": "Curated by The Retreat",
    "fullName": "Curated by The Retreat"
  },
  "RETREAT_EXTEND": {
    "productType": "pagePackage",
    "displayName": "Extend and indulge ",
    "fullName": "Extend and indulge "
  },
  "SILICA_ONLINE_RACK": {
    "productType": "pagePackage",
    "displayName": "Stay at Silica Hotel",
    "fullName": "Stay at Silica Hotel"
  },
  "SILICA_ATV": {
    "productType": "pagePackage",
    "displayName": "Culinary Delights & ATV Thrills",
    "fullName": "Culinary Delights & ATV Thrills"
  },
  "SILICA DEKUR": {
    "productType": "pagePackage",
    "displayName": " Slip Away To Silica Hotel",
    "fullName": " Slip Away To Silica Hotel"
  },
  "SILICA_WONDER": {
    "productType": "pagePackage",
    "displayName": "Years Of Wonder ",
    "fullName": "Years Of Wonder "
  },
  "SILICA+LAVA": {
    "productType": "pagePackage",
    "displayName": "A Night at Silica Hotel with Dinner at Lava Restaurant​",
    "fullName": "A Night at Silica Hotel with Dinner at Lava Restaurant​"
  },
  "SILICA_GOURMET": {
    "productType": "pagePackage",
    "displayName": "Classic Cuisine & In-Water Treatments",
    "fullName": "Classic Cuisine & In-Water Treatments"
  },
  "SIL+RETREATSPA": {
    "productType": "pagePackage",
    "displayName": "Silica Hotel & the Retreat Spa",
    "fullName": "Silica Hotel & the Retreat Spa"
  },
  "GOURMET GETAWAY": {
    "productType": "pagePackage",
    "displayName": "A Gourmet Getaway",
    "fullName": "A Gourmet Getaway"
  },
  "STAY LONGER": {
    "productType": "pagePackage",
    "displayName": "Stay Longer",
    "fullName": "Stay Longer"
  },
  "RETREAT_EXPLORATION": {
    "productType": "pagePackage",
    "displayName": "Luxurious Exploration & Radiant Rejuvenation",
    "fullName": "Luxurious Exploration & Radiant Rejuvenation"
  },
  "RETREAT_SOLO": {
    "productType": "pagePackage",
    "displayName": "Solo Sojourn",
    "fullName": "Solo Sojourn"
  },
  "LUXURY GETAWAY": {
    "productType": "pagePackage",
    "displayName": "Luxury Getaway",
    "fullName": "Luxury Getaway"
  },
  "RETREAT_ONLINE_RACK": {
    "productType": "pagePackage",
    "displayName": "Stay at Retreat Hotel",
    "fullName": "Stay at Retreat Hotel"
  },
  "RETREAT_30YEARS": {
    "productType": "pagePackage",
    "displayName": "30 Years Of Wonder",
    "fullName": "30 Years Of Wonder"
  },
  "RETREAT+MOSS": {
    "productType": "pagePackage",
    "displayName": "A Night at The Retreat & Dinner at Moss​",
    "fullName": "A Night at The Retreat & Dinner at Moss​"
  },
  "SILICA XMAS": {
    "productType": "pagePackage",
    "displayName": "Holidays at Silica Hotel ",
    "fullName": "Holidays at Silica Hotel "
  },
  "RETREAT XMAS": {
    "productType": "pagePackage",
    "displayName": "Holiday Retreat",
    "fullName": "Holiday Retreat"
  },
  "SILICA_30YEARS": {
    "productType": "pagePackage",
    "displayName": "30 Years Of Wonder",
    "fullName": "30 Years Of Wonder"
  },
  "highlandBaseTransfer": {
    "productType": "activityCard",
    "displayName": "Transfer",
    "fullName": "Transfer"
  },
  "mossRestaurant": {
    "productType": "activityCard",
    "displayName": "Michelin-dining at Moss",
    "fullName": "Michelin-dining at Moss"
  },
  "spa-restaurant": {
    "productType": "activityCard",
    "displayName": "Dine at Spa Restaurant",
    "fullName": "Dine at Spa Restaurant"
  },
  "privateTransfer": {
    "productType": "activityCard",
    "displayName": "Book private transfers",
    "fullName": "Book private transfers"
  },
  "float": {
    "productType": "activityCard",
    "displayName": "Book float therapy ",
    "fullName": "Book float therapy "
  },
  "massage": {
    "productType": "activityCard",
    "displayName": "Book an in-water massage",
    "fullName": "Book an in-water massage"
  },
  "skincare": {
    "productType": "activityCard",
    "displayName": "Silica Mud Mask",
    "fullName": "Silica Mud Mask"
  },
  "highlandBaseBaths": {
    "productType": "activityCard",
    "displayName": "Highland Base Baths",
    "fullName": "Highland Base Baths"
  },
  "lava": {
    "productType": "activityCard",
    "displayName": "Reserve a table at Lava Restaurant",
    "fullName": "Reserve a table at Lava Restaurant"
  },
  "Snowmobile": {
    "productType": "activityCard",
    "displayName": "Snowmobile adventure ",
    "fullName": "Snowmobile adventure "
  },
  "highlandBaseBuggyRide": {
    "productType": "activityCard",
    "displayName": "Buggy tour",
    "fullName": "Buggy tour"
  },
  "privateTransferTheRetreat": {
    "productType": "activityCard",
    "displayName": "Book your private transfer",
    "fullName": "Book your private transfer"
  },
  "highlandBaseRestaurant": {
    "productType": "activityCard",
    "displayName": "Highland Base Restaurant",
    "fullName": "Highland Base Restaurant"
  }
};
